import React from "react";
import { Landmark } from "lucide-react";
import SacredChatPage from "./SacredChatPage";
import { PLAYLISTS } from "@/lib/tracks";

export default function OracleDelphe() {
  return (
    <SacredChatPage
      persona="delphe"
      personaLabel="Oracle de Delphes"
      IconComponent={Landmark}
      accent="#ffcf5a"
      theme={{
        bgRadial: "radial-gradient(ellipse at top, #3a2606 0%, #1a1004 55%, #060300 100%)",
        fg: "#fff6dc",
        msgBg: "linear-gradient(180deg, rgba(36,24,6,0.94), rgba(10,6,0,0.96))",
        msgFg: "#f8de98",
      }}
      title={{
        fr: <>L'<span className="italic" style={{ color: "#ffcf5a" }}>Oracle de Delphes</span>.</>,
        en: <>The <span className="italic" style={{ color: "#ffcf5a" }}>Oracle of Delphi</span>.</>,
      }}
      subtitle={{
        fr: "☀️ Sur le trépied d'or, Apollon parle par la Pythie. Il ne lit pas l'avenir : il te délivre une éclatante vérité sur ce que tu vis déjà. « Connais-toi toi-même · Rien de trop. »",
        en: "☀️ On the golden tripod, Apollo speaks through the Pythia. He does not read the future: he delivers a dazzling truth about what you are already living. \"Know thyself · Nothing in excess.\"",
      }}
      greeting={{
        fr: "« Mortel, entre dans le temple. Pose ta question : la lumière ne ment pas. »",
        en: "\"Mortal, enter the temple. Ask your question: light does not lie.\"",
      }}
      suggestions={{
        fr: [
          "Pourquoi je repousse toujours ce projet ?",
          "Qu'est-ce que je refuse de voir dans ma relation ?",
          "Pourquoi ai-je peur du regard des autres ?",
          "Quelle vérité ai-je besoin d'entendre aujourd'hui ?",
        ],
        en: [
          "Why do I keep postponing this project?",
          "What am I refusing to see in my relationship?",
          "Why am I afraid of what others think?",
          "What truth do I need to hear today?",
        ],
      }}
      playlist={PLAYLISTS.apollon}
      replySound={`${process.env.REACT_APP_BACKEND_URL}/api/static/audio/apollon_lyre.mp3`}
      sfxEmoji="🎵"
      sfxLabel={{ fr: "la lyre", en: "the lyre" }}
    />
  );
}
